// extracted by mini-css-extract-plugin
export default {"root":"JmLaECLOrBKr_R6ubNGQ","heading":"PV2L8UkA6NkUNywFJibq","description":"DTHVmu2WNJIdSpyTxmwq"};